<template lang="pug"
src='./floors-roofs-addition.pug'>

</template>

<script>
import {EventBus} from '@/common/event-bus'
import saveBtn from '@/common/components/saveBtn.vue'
import imgIcon from '@/common/img/baseline-clear-24px.svg'
import floorImageReferenceModal from './pops/floorReferenceSvg.vue'
import easyBtn from 'Common/components/easy-btn.vue'

export default {
	name: 'floors-roofs-addition',
	props: ['project', 'control', 'readonly', 'findControlTextByKey'],
	components: {
		saveBtn,
		floorImageReferenceModal,
		easyBtn
	},
	data () {
		return {
			wichInfo: '',
			description: '',
			imgIconDel: imgIcon,
			popUp: false,
			projType: {},
			typeLabel: 'Addition'
		}
	},
	created: function () {
		this.projType = process.env.PROJTYPE
		if (this.project.takeoff === this.projType.conversion) {
			this.typeLabel = 'Conversion'
		} else {
			this.typeLabel = 'Addition'
		}
		this.TotalExistingFloors()
		this.TotalAdditionFloor()
	},
	methods: {
		addRoof () {
			this.project.floorsRoofs.roofs.push(
				{
					rebuiltAttic: '',
					area: 0,
					slope: '0.0',
					orient: 0,
					depth: ''
				}
			)
		},
		deleteRoof (index) {
			this.project.floorsRoofs.roofs.splice(index, 1)
		},
		addVault () {
			this.project.floorsRoofs.vaults.push(
				{
					orient: 90,
					area: 0,
					slope: '0.0',
					deep: ''
				}
			)
		},
		deleteVault (index) {
			this.project.floorsRoofs.vaults.splice(index, 1)
		},
		showModalFromInfo (value) {
			this.popUp = true
			this.wichInfo = value
			// EventBus.$emit('open-floors-svg-reference-popUp', value)
		},
		showModalInTakeoff (value) {
			EventBus.$emit('open-type-building-popUp', value)
		},
		hideModal () {
			// this.$refs.contextualHelp.hide()
			this.popUp = false
			this.wichInfo = ''
		},
		TotalExistingFloors () {
			let slab = Number(this.project.floorsRoofs.slabArea || 0)
			let upperOver = Number(this.project.floorsRoofs.upperOverCondSpaceArea || 0)
			let overOpen = Number(this.project.floorsRoofs.overOpenSpaceArea || 0)
			let overEnc = Number(this.project.floorsRoofs.overEncGarageArea || 0)
			let overAdd = Number(this.project.floorsRoofs.overAdditionArea || 0)
			let intCond = Number(this.project.floorsRoofs.interiorCondArea || 0)
			let res = Number(slab + upperOver + overOpen + overEnc + overAdd + intCond || 0)
			this.project.floorsRoofs.totalCondArea = res
		},
		TotalAdditionFloor () {
			let slabA = Number(this.project.floorsRoofs.slabAreaAddition || 0)
			let upperOverA = Number(this.project.floorsRoofs.upperOverCondSpaceAreaAddition || 0)
			let overOpenA = Number(this.project.floorsRoofs.overOpenSpaceAreaAddition || 0)
			let overEncA = Number(this.project.floorsRoofs.overEncGarageAreaAddition || 0)
			let overExst = Number(this.project.floorsRoofs.overExistingArea || 0)
			let intAdd = Number(this.project.floorsRoofs.interiorAddArea || 0)
			let res = Number(slabA + upperOverA + overOpenA + overEncA + overExst + intAdd || 0)
			this.project.floorsRoofs.totalAddition = res
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/take-off-tool/tabs-components/floors-roofs-addition.vue